module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "arial"
    }
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_vm._v("Grilled Apricot Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-14"
  }, [_vm._v("This is the ideal appetizer. Set it out in a bowl and put a bag of chips next to it. Everyone knows the drill.")])])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5 color-3C1C00"
  }, [_vm._v("Makes about ")]), _c('span', {
    staticClass: "yield color-FF5100"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1 ")])]), _c('span', {
    staticClass: "yield color-3C1C00"
  }, [_c('span', {
    staticClass: "yield font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("cup")])])]), _vm._v(" "), _c('div', {
    staticClass: "blocktext"
  }, [_c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("ripe apricots, cut in half and pits removed "), _c('br'), _vm._v("Spray cooking oil "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11"
  }, [_vm._v("½")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("medium onion, peeled and cut widthwise into ")])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("½")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("-inch slices "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("red bell pepper, stemmed, seeded, and cut into ")])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("-inch pieces "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("8")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Roma tomatoes, chopped (see Note) "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("scallions, green parts only, finely chopped "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11"
  }, [_vm._v("¼")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("cup cilantro leaves "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("tablespoon fresh lime juice "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("2")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("teaspoons chili powder "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("teaspoon ground cumin "), _c('br')])]), _c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("teaspoon salt "), _c('br'), _vm._v("Dash Tabasco or other favorite hot sauce "), _c('br'), _vm._v("Tortilla chips, for serving")])])])]), _vm._v(" "), _c('p', {
    staticClass: "method_text"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-FFDingbats-ArrowsOne-11_1-14"
  }, [_vm._v("→")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Prepare ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("enough coals for a hot charcoal fire, or preheat your gas grill on high for 10 minutes with the lid closed.")])])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("While ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the grill is heating up, arrange the apricot halves on a platter, cut sides up, and spray them liberally with oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("When ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the coals are ready or the gas grill is hot, grill the apricots, cut sides down, for 4 to 5 minutes, until they are a deep golden brown. Spray the tops with oil and use a spatula to turn them over. Grill for 2 minutes more, then transfer to a platter and let them cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Place ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("the onion, bell pepper, Roma tomatoes, scallions, cilantro, lime juice, chili powder, cumin, salt, and Tabasco into the container of a food processor, along with the cooled apricots, and pulse until finely chopped but not smooth.")])]), _vm._v(" "), _c('p', {
    staticClass: "method_text color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Transfer ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-12"
  }, [_vm._v("to a bowl and serve with tortilla chips.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Note: ")])]), _c('span', {
    staticClass: "color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AtmaSerif-MediumItalic-6_1-12"
  }, [_vm._v("If you can’t find any decent fresh tomatoes, you can substitute canned whole tomatoes.")])])])])]), _c('a', {
    attrs: {
      "id": "p26"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c43ace","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/018chapter12.vue
// module id = 108
// module chunks = 0